import { useContext, useState } from "react"

import { LocaleContext } from "../../components/Layout"

export default function useCaptcha(errorsVisible) {
  const errorMessage = useContext(LocaleContext).ui.forms.errors.captcha
  const [passed, setPassed] = useState(false)
  const [expired, setExpired] = useState(false)
  const valid = !expired && passed

  return {
    valid,
    props: {
      errorMessage: errorsVisible && !valid ? errorMessage : undefined,
      onChange: handleCaptchaChange,
    },
  }

  function handleCaptchaChange(value) {
    if (value === null) return setExpired(true)

    setExpired(false)
    setPassed(value)
  }
}
